<template>
  <div no-body class="lku-koran-campign">
    <b-row v-if="lkuLoading" class="justify-content-center mb-2">
      <span style="color:blue;">Loading data ...</span>
    </b-row>
    <b-row v-else>
      <b-col lg="9">
        <b-form-group
          style="margin-bottom:-4px !important;"
          horizontal
          label="Search :"
          label-cols="1"
        >
          <b-row>
            <b-col class="pl-1 pr-1" cols="6">
              <b-form-input
                v-model="tblData.searchTxt"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Type for searching"
              ></b-form-input>
            </b-col>
            <b-col cols="3">
              <b-form-group style="margin-bottom:-4px !important;" horizontal>
                <b-row>
                  <b-button class="btn btn-success mr-1" @click="refresh()" size="sm">
                    <i class="fa fa-search"></i> Search
                  </b-button>
                  <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm">
                    <i class="fa fa-eraser"></i>Clear
                  </b-button>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      class="mb-0"
      ref="tblKoranCust"
      responsive
      striped
      hover
      small
      style="font-size:smaller;"
      :items="data"
      :fields="fields"
      :current-page="tblData.page"
      :per-page="tblData.limit"
      :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit"
      @row-clicked="selectItem"
    >
        <template v-slot:cell(nomor)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
        </template>
        <template v-slot:cell(kiriman_name)="data">
          {{data.item.kiriman_name }} | {{data.item.kiriman_code}}
        </template>

    </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
.lku-adv {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import crud from "../../apis/crud";
import moment from "moment";

export default {
  data() {
    return {
      items: [],
      fields: [
        {
          key: "nomor",
          thStyle: "width:50px",
          label: "No."
        },
        {
          key: "uraian",
          label: "Nama Campaign/Promo/Program",
          sortable: true
        },
        {
          key: "kiriman_name",
          label: "Jenis Kiriman",
          sortable: true
        },
        {
          key: "periode",
          label: "Periode",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
      ],
      tblData: {
        tablename: "korancampaign",
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'uraian',
        sortDesc: false,
        outstand: "1"
      },
      lkuLoading: false
    };
  },
  props: ["filter"],
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let str = "";
      this.tblData.searchTxt = this.tblData.searchTxt || "";
      // if (this.tblData.searchTxt){
      str = "uraian=%" + encodeURIComponent(this.tblData.searchTxt);
      // }
      this.tblData.customQuery = str;
      const list = await crud.list(this.tblData);
      // list.forEach((el, idx) => {
      //   list[idx].tanggal = moment(el.tanggal).format("YYYY-MM-DD");
      //   list[idx].startdate = moment(el.startdate).format("YYYY-MM-DD");
      //   list[idx].enddate = moment(el.enddate).format("YYYY-MM-DD");
      //   let a = moment(list[idx].enddate);
      //   let b = moment(new Date());
      //   list[idx].status = a.diff(b, "days") < 0 ? "Berakhir" : "Aktif";
      //           list[idx].isExpired =  false;

      //   // list[idx].isExpired = a.diff(b, "days") < 0 ? true : false;
      // });
      return list;
    },

    selectItem(item, index) {
      this.$emit("click", item);
    },
    clearFilter() {
      this.tblData.name = "";
      this.tblData.code = "";
      this.tblData.customer_group = "";
      this.tblData.SalesCode = "";
      this.refresh();
    },
    refresh: async function() {
      this.$refs.tblKoranCust.refresh();
    }
  }
};
</script>
